import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./index.scss";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from './store/store';
import { Toaster } from "react-hot-toast";

import "./assets/scss/materio/core.scss";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={store}>    
    <BrowserRouter>
     <Toaster />
        <App />
    </BrowserRouter>
    </Provider>
);

